import { selectUser } from 'ducks/modules/user';
import _ from 'lodash';

export function hasAuthToken() {
    return localStorage.getItem('access_token') !== null && localStorage.getItem('access_token') !== 'null';
}

export function getAuthHeader() {
    return 'Bearer ' + localStorage.getItem('access_token');
}

export function isAdmin() {
    const user = selectUser();
    if (user.username === 'ADMIN') {
        return true;
    }
    return false;
}

export function isImpelMember() {
    const user = selectUser();
    if (user?.user_preferences?.impel && user?.source_type === 'PB') {
        return true;
    }
    return false;
}

/**
 *
 * @returns {boolean} true if user is an impel admin
 */
export function isImpelAdmin() {
    const user = selectUser();
    if (user?.user_preferences?.impel?.admin && user?.source_type === 'M') {
        return true;
    }
    return false;
}

/**
 * @returns {boolean} true if user is an DnD subscriber
 * @description
 * DnD subscriber is a user who has access to DnD
 */

export function isDndSubscriber() {
    const user = selectUser();
    if (!_.isEmpty(user?.user_preferences?.subscription?.drag_and_drop) && user?.source_type === 'M') {
        return true;
    }
    return false;
}

/**
 * @returns {boolean} true if user is an Blokur user
 */

export function isBlokurUser() {
    const user = selectUser();
    if (user?.email.includes('@blokur.com')) {
        return true;
    }
    return false;
}

export function isEmpty() {
    const user = selectUser();
    return Boolean(user) && Object.keys(user).length === 0;
}
